var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5C10.3359 2.5 2.5 10.3359 2.5 20C2.5 29.6641 10.3359 37.5 20 37.5C29.6641 37.5 37.5 29.6641 37.5 20C37.5 10.3359 29.6641 2.5 20 2.5ZM27.5 20.9375C27.5 21.1094 27.3594 21.25 27.1875 21.25H21.25V27.1875C21.25 27.3594 21.1094 27.5 20.9375 27.5H19.0625C18.8906 27.5 18.75 27.3594 18.75 27.1875V21.25H12.8125C12.6406 21.25 12.5 21.1094 12.5 20.9375V19.0625C12.5 18.8906 12.6406 18.75 12.8125 18.75H18.75V12.8125C18.75 12.6406 18.8906 12.5 19.0625 12.5H20.9375C21.1094 12.5 21.25 12.6406 21.25 12.8125V18.75H27.1875C27.3594 18.75 27.5 18.8906 27.5 19.0625V20.9375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.4e8a13d81fd0be6e14fd8522137f5a8b.svg";
export { ForwardRef as ReactComponent };